




/* ====================================================================================
外部リンクで開く
==================================================================================== */
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}




// ====================================================================================
// ヘッダー：メガメニュー制御
// ====================================================================================
document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.custom-mega-menu') || document;
    const items = container.querySelectorAll('.l-header__item');
    const overlay = container.querySelector('.mega-menu__overlay');
    const canHover = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

    const getMenu = (item) => item.querySelector('.mega-menu');
    const getPanel = (item) => item.querySelector('.mega-menu__panel');

    // 実寸を計測して max-height に反映
    const setMaxHeightToContent = (menu, panel) => {
        if (!menu || !panel) return;
        const h = panel.scrollHeight;
        menu.style.setProperty('--mm-h', `${h}px`);
        menu.style.maxHeight = `${h}px`;
    };

    const closeItem = (item) => {
        const menu = getMenu(item);
        if (!menu) return;
        item.classList.remove('is-active');
        menu.classList.remove('is-open');
        menu.style.maxHeight = '0px';
    };

    const closeAll = () => {
        items.forEach(i => {
            i.classList.remove('is-inactive');
            closeItem(i);
        });
        overlay?.classList.remove('is-open');
    };

    const openItem = (item) => {
        if (!item.classList.contains('has-mega-menu')) return;

        // 他をinactive + 閉じる
        items.forEach(i => {
            if (i !== item) {
                i.classList.add('is-inactive');
                closeItem(i);
            }
        });

        const menu = getMenu(item);
        const panel = getPanel(item);
        if (!menu || !panel) return;

        item.classList.add('is-active');
        menu.classList.add('is-open');

        // 開くときも滑らかに：0を明示 → 次フレームで実寸
        menu.style.maxHeight = '0px';
        // 実寸をセット（requestAnimationFrame でトランジション発火）
        requestAnimationFrame(() => {
            setMaxHeightToContent(menu, panel);
        });

        overlay?.classList.add('is-open');
    };

    // ================= PC: hover =================
    if (canHover) {
        items.forEach(item => {
            item.addEventListener('mouseenter', () => {
                if (item.classList.contains('has-mega-menu')) {
                    openItem(item);
                } else {
                    // メガメニューを持たない要素に乗ったら閉じる
                    closeAll();
                }
            });
            item.addEventListener('mouseleave', () => {
                // 仕様：ホバーを外したら閉じる
                closeAll();
            });
        });

        overlay?.addEventListener('mouseenter', closeAll);
        overlay?.addEventListener('click', closeAll);

        // ================= Touch/Tablet: click =================
    } else {
        items.forEach(item => {
            const link = item.querySelector('.l-header__link');
            if (!link) return;

            link.addEventListener('click', (e) => {
                const hasChildren = link.dataset.hasChildren === 'true';
                if (!hasChildren) return; // 子が無ければ通常遷移

                e.preventDefault();
                const isActive = item.classList.contains('is-active');
                if (isActive) {
                    // 閉じる
                    closeItem(item);
                    items.forEach(i => i.classList.remove('is-inactive'));
                    overlay?.classList.remove('is-open');
                } else {
                    // 開く
                    openItem(item);
                }
            });
        });

        // 外クリックで閉じる
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.custom-mega-menu')) closeAll();
        });
    }

    // ================ リサイズ対応：開いているものだけ再測定 ================
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            const active = container.querySelector('.l-header__item.is-active');
            if (!active) return;
            const menu = getMenu(active);
            const panel = getPanel(active);
            if (!menu || !panel) return;
            setMaxHeightToContent(menu, panel);
        }, 120);
    });
});





/* ====================================================================================
ヘッダー：アカウントメニュー制御
==================================================================================== */

document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('.account-menu-toggle');
    const menu = document.querySelector('.account-menu');
    const overlay = document.querySelector('.account-menu__overlay');

    if (toggle && menu && overlay) {
        toggle.addEventListener('click', function (e) {
            e.stopPropagation(); // イベントのバブリングを防止
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', !isExpanded);
            menu.hidden = isExpanded;
            overlay.hidden = isExpanded;
        });

        // オーバーレイをクリックして閉じる
        overlay.addEventListener('click', function () {
            toggle.setAttribute('aria-expanded', false);
            menu.hidden = true;
            overlay.hidden = true;
        });

        // 外側クリックで閉じる
        document.addEventListener('click', function (e) {
            if (!toggle.contains(e.target) && !menu.contains(e.target)) {
                toggle.setAttribute('aria-expanded', false);
                menu.hidden = true;
                overlay.hidden = true;
            }
        });

        // メニュー内部クリックで閉じないようにする
        menu.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    }
});

